import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuthMe } from '../api/queries';

/**
 * Gate a route on the visitor being signed in. While useAuthMe is still
 * pending, render nothing — the resolution is fast (single GET) and a
 * flash of either the protected page or the sign-in redirect is worse
 * than a brief blank. On 401, redirect to /sign-in with a return param
 * so SignInPage can drop the user back where they meant to go.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useAuthMe();
  const location = useLocation();

  if (me.isLoading) return null;
  if (me.error || !me.data) {
    const target = location.pathname + location.search;
    return (
      <Navigate
        to={`/sign-in?return=${encodeURIComponent(target)}`}
        replace
      />
    );
  }
  return <>{children}</>;
}
